/**
 * Refaz a prévia de UMA conversa quando a pessoa pede ("Atualizar prévia" ou
 * "Gerar agora") e devolve o item novo para a lista via `aoAtualizarItem`.
 * Nada sai sozinho: abrir a conversa usa a prévia da última rodada, e cada
 * pedido gasta 1 da cota do Gemini no dia (a releitura da cota vem junto).
 * O erro é o `detalhe` do servidor, como veio.
 */
import { useCallback, useEffect, useRef, useState } from "react";

import { useAuth } from "../../../context/AuthContext";
import { atualizarPrevia } from "../../../services/centralProjetos";
import useGeminiHoje from "../useGeminiHoje";

export default function usePrevia(conversa, aoAtualizarItem) {
  const { request } = useAuth();
  const { gemini, recarregar, absorver } = useGeminiHoje();
  const [estado, setEstado] = useState({ carregando: false, erro: "" });
  const vivo = useRef(true);

  useEffect(() => {
    vivo.current = true;
    return () => {
      vivo.current = false;
    };
  }, []);

  const gerar = useCallback(async () => {
    setEstado({ carregando: true, erro: "" });
    try {
      const item = await atualizarPrevia(request, conversa.id);
      if (item?.gemini_hoje) absorver(item.gemini_hoje);
      else recarregar();
      if (!vivo.current) return;
      aoAtualizarItem(item);
      setEstado({ carregando: false, erro: "" });
    } catch (erro) {
      recarregar();
      if (vivo.current) setEstado({ carregando: false, erro: erro?.message || "A prévia não saiu agora." });
    }
  }, [request, conversa.id, aoAtualizarItem, recarregar, absorver]);

  return { estado, gerar, gemini };
}
